
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44.23 64.44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M35.77 24.92V13.65a13.66 13.66 0 00-27.31 0v11.27a22.12 22.12 0 1027.31 0zM16.91 50.65l2.73-10.14a4.93 4.93 0 114.95 0l2.73 10.14zm14.86-28.23a22.2 22.2 0 00-19.31 0v-8.77a9.66 9.66 0 0119.31 0z","fill":"#fff","data-name":"Layer 1"}})])])
          )
        }
      }
    